import { AppThunk } from '../../type'

import {
  error,
  finish,
  loading,
  setChatsList,
  appendChatList,
  resetUnreadMessagesForChat,
  deleteChat,
  appendSingleChat
} from './slice'

import {
  GetChatListRequestArgs,
  getChatListRequestAsync,
  readChatMessages
} from 'features/ChatList/api'
import { deleteChatRequest } from '../../../features/Chat/DeleteModal/api'
import { IChatDetails } from '../chatDetails/types'
import { getUnreadMessagesActionAsync } from '../chatSocket/actions'
import { removeUnreadSocketMessagesByChatId } from '../chatSocket/slice'
import { resetUnreadMessages } from '../chatDetails/slice'
import { updateReadByUsers } from '../chatHistory/slice'

// This action is required to get chat that currently not presented in the list
// however when such chat has some unread messages in it
export const getLatestUnreadChat = (): AppThunk => async (dispatch) => {
  try {
    const { data } = await getChatListRequestAsync({ limit: 1, offset: 0 })

    if (data && data.results.length > 0) {
      dispatch(removeUnreadSocketMessagesByChatId(data.results[0].uuid))
      dispatch(appendSingleChat(data.results[0]))
    }
    await Promise.resolve()
  } catch (err) {
    dispatch(error({ error: err }))
    await Promise.reject(err)
  } finally {
    dispatch(finish())
  }
}

export const getChatListActionAsync =
  (args: GetChatListRequestArgs): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(loading())

      const { data } = await getChatListRequestAsync(args)

      if (data) {
        dispatch(
          removeUnreadSocketMessagesByChatId(
            data.results.map((chat) => chat.uuid)
          )
        )
        if (args?.offset && Number(args.offset) !== 0) {
          dispatch(appendChatList(data.results))
        } else {
          dispatch(
            setChatsList({
              ...data,
              type: args.type || null,
              search: args.search || null
            })
          )
        }
      }
      await Promise.resolve()
    } catch (err) {
      dispatch(error({ error: err }))
      await Promise.reject(err)
    } finally {
      dispatch(finish())
    }
  }

export const resetUnreadMessageCount =
  (id: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(loading())

      await readChatMessages(id)
      // refresh chat history
      dispatch(updateReadByUsers({ chatId: id }))
      // refresh outer indicator
      dispatch(getUnreadMessagesActionAsync())
      // reset for socket stack
      dispatch(removeUnreadSocketMessagesByChatId(id))
      // reset for list view
      dispatch(resetUnreadMessagesForChat({ uuid: id }))
      // reset for details view
      dispatch(resetUnreadMessages())
    } catch (err) {
      dispatch(error({ error: err }))
      await Promise.reject(err)
    } finally {
      dispatch(finish())
    }
  }

export const deleteChatAction =
  (selectedChat: IChatDetails): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(loading())
      await deleteChatRequest(
        selectedChat.uuid,
        selectedChat.type === 'private'
      )
      dispatch(deleteChat(selectedChat.uuid))
    } catch (err) {
      dispatch(error({ error: err }))
      await Promise.reject(err)
    } finally {
      dispatch(finish())
    }
  }
